import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { PlusIcon } from 'lucide-react';
import { faqItems } from '../data/content';
export function Faq() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section aria-labelledby="faq-titulo" className="w-full bg-celeste-light py-14 sm:py-20" data-id="element-60" data-mp="1l9o6t8rmrzlq">
      <div className="mx-auto max-w-3xl px-5" data-id="element-61" data-mp="1gaus5d0ly2jz">
        <h2 id="faq-titulo" className="text-center font-display text-2xl font-extrabold uppercase tracking-wide text-navy sm:text-3xl" data-id="element-62" data-mp="2dzeo1qok7hm2">
          ❓ Lo que más nos preguntan
        </h2>

        <ul className="mt-8 space-y-3" data-id="element-63" data-mp="240p29mtjld0j">
          {faqItems.map((item, index) => {
          const isOpen = openIndex === index;
          return <li key={item.question} className="overflow-hidden rounded-2xl border border-navy/10 bg-white shadow-card" data-id="element-64" data-mp="smuzg7jqk22r" data-mpi={index}>
                <h3 data-id="element-65" data-mp="nqd0xpf00zyv">
                  <button type="button" onClick={() => setOpenIndex(isOpen ? null : index)} aria-expanded={isOpen} aria-controls={`faq-panel-${index}`} className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left font-display text-base font-bold text-navy transition-colors hover:bg-cream focus-visible:outline focus-visible:outline-2 focus-visible:-outline-offset-2 focus-visible:outline-celeste-dark sm:text-lg" data-id="element-66" data-mp="pi7hkfvx0ume">
                    {item.question}
                    <PlusIcon className={`h-5 w-5 shrink-0 text-celeste-dark transition-transform duration-200 ${isOpen ? 'rotate-45' : ''}`} aria-hidden="true" data-id="element-67" data-mp="3syod6fixr93i" />
                  </button>
                </h3>

                <AnimatePresence initial={false} data-id="element-68" data-mp="3o039250kc59s">
                  {isOpen && <motion.div id={`faq-panel-${index}`} initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.25,
                ease: 'easeOut'
              }} className="overflow-hidden" data-id="element-69" data-mp="1ugkuq37ului8">
                      <p className="border-t border-navy/10 px-5 py-4 text-sm leading-relaxed text-navy/80 sm:text-base" data-id="element-70" data-mp="2dfgojdfso6vj">
                        {item.answer}
                      </p>
                    </motion.div>}
                </AnimatePresence>
              </li>;
        })}
        </ul>
      </div>
    </section>;
}